export default {
    MINIMUM_TO_DISPLAY: 1,
    MAX_ELEMENTS_IN_STORAGE: 20,
    MAX_ITEMS_TO_DISPLAY: 20,
    NUMBER_OF_DAYS_VALID_CACHE: 30,
    STORAGE_KEY: 'recentlyViewed',
};
